import {NotificationBridge} from '../notificationBridge';

const notificationWeb: NotificationBridge = {
    registerResponseCallback: async (): Promise<void> => undefined
};

export default notificationWeb;
